<ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand" let-onCheckedChange="onCheckedChange">
  <div class="form-inline d-flex">
    @if (item.children) {
      <i class="mr-1" (click)="onCollapseExpand()" aria-hidden="true">
        @switch (item.collapsed) {
          @case (true) {
            <svg width="0.8rem" height="0.8rem" viewBox="0 0 16 16" class="bi bi-caret-right-fill"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
            </svg>
          }
          @case (false) {
            <svg width="0.8rem" height="0.8rem" viewBox="0 0 16 16" class="bi bi-caret-down-fill"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
            </svg>
          }
        }
      </i>
    }
    <div class="form-check d-flex justify-content-between treeview-item" [ngClass]="{'collapsable-item': item.children }">
      @switch (true) {
        @case (item.type === TreeviewItemTypeEnum.Projet) {
          <span class="d-flex align-items-center">
            <i class="fas fa-suitcase"></i>
            <label class="form-check-label" (click)="item.checked = true; onCheckedChange(); onLabelClick(item)">
              {{item.text}}
            </label>
          </span>
          <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onCheckedChange()"
            [disabled]="item.disabled" [indeterminate]="item.indeterminate" />
          }
          @case (item.type === TreeviewItemTypeEnum.Tir || item.type === TreeviewItemTypeEnum.TirRealise) {
            <span class="d-flex align-items-center" [ngClass]="{'item-selected': tirPopup() === item.value}">
              <i class="fas fa-compress-arrows-alt"></i>
              <label  class="form-check-label" (click)="onCheckedChange(item.text);  onLabelClick(item)">
                {{item.text}}
              </label>
            </span>
            <input  type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onCheckedChange()"
              [disabled]="item.disabled" [indeterminate]="item.indeterminate" />
            }
            @default {
              <span class="d-flex align-items-center">
                <label  class="form-check-label" (click)="item.checked = true; onCheckedChange(); onLabelClick(item)">
                  {{item.text}}
                </label>
              </span>
              <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onCheckedChange()"
                [disabled]="item.disabled" [indeterminate]="item.indeterminate" />
              }
            }
          </div>
        </div>
      </ng-template>

      <ng-template #itemTemplateNoSelection let-item="item" let-onCollapseExpand="onCollapseExpand" let-onCheckedChange="onCheckedChange" let-parent="parent">
        <div class="form-inline d-flex">
          @if (item.children) {
            <i class="mr-1" (click)="onCollapseExpand()" aria-hidden="true">
              @switch (item.collapsed) {
                @case (true) {
                  <svg width="0.8rem" height="0.8rem" viewBox="0 0 16 16" class="bi bi-caret-right-fill"
                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                }
                @case (false) {
                  <svg width="0.8rem" height="0.8rem" viewBox="0 0 16 16" class="bi bi-caret-down-fill"
                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                }
              }
            </i>
          }
          <div class="form-check d-flex justify-content-between treeview-item" [ngClass]="{'collapsable-item': item.children }">
            @switch (true) {
              @case (item.type === TreeviewItemTypeEnum.Projet) {
                <span class="d-flex align-items-center" [ngClass]="{'item-selected': !utilService.currentTir && !router.url.includes('nodeId') && utilService.currentProjet?.projetId === item.value}">
                  <i class="fas fa-suitcase"></i>
                  <a [routerLink]="['/mysite', utilService.currentSite()?.siteId, 'myprojects', item.value]" title="{{item.text}}">
                    {{item.text}}
                  </a>
                </span>
              }
              @case (item.type === TreeviewItemTypeEnum.Tir || item.type === TreeviewItemTypeEnum.TirRealise) {
                <span class="d-flex align-items-center" [ngClass]="{'item-selected': utilService.currentTir?.tirId === item.value}">
                  <i class="fas fa-compress-arrows-alt"></i>
                  <a [routerLink]="['/mysite', utilService.currentSite()?.siteId, 'myprojects', item.projetId]" [queryParams]="{blastId: item.value}"
                    class="w-100 limited-link" title="{{item.text}}">
                    {{item.text}}
                  </a>
                </span>
              }
              @default {
                <span class="d-flex align-items-center" [ngClass]="{'item-selected': isNodeActive(item)}">
                  <a (click)="handleNodeRouting(item.text, item.projetId, item.value, item.identifiant)" class="w-100" title="{{item.identifiant}}">
                    {{item.text}}
                  </a>
                </span>
              }
            }
            @if (item.blasted) {
              <i class="fas fa-check" title="{{'TIR.TIR_EFFECTUE' | translate}}"></i>
            }
          </div>
        </div>
      </ng-template>
      @if (canCreateTir() && projetId() != null) {
        <div class="create-tir-button-container">
          <button *showIfHasRole="'create_blast'" class="primary-button" (click)="openModalcreateTir()"><i class="fas fa-plus me-2"></i>{{'TIR.CREER_UN_TIR' | translate}}</button>
        </div>
      }

      <ng-template #defaultHeaderTemplate let-config="config" let-item="item" let-onCollapseExpand="onCollapseExpand"
        let-onCheckedChange="onCheckedChange" let-onFilterTextChange="onFilterTextChange">
        @if (config?.hasFilter) {
          <div class="row row-filter">
            <div class="col-12">
              <input class="form-control" type="text" [placeholder]="'TREEVIEW.PLACEHOLDER_FILTRE' | translate" [ngModel]="filterText()" (ngModelChange)="onFilterTextChange($event)" />
            </div>
          </div>
        }


        <div class="form-check projets-actifs">
          <input class="form-check-input" type="checkbox" [attr.data-attr]="'treeview-projects-actifs'" [ngModel]="actifProjectsOnly()" (ngModelChange)="onCheckboxActiveProjectChange($event)"/>
          <label class="form-check-label" for="projetsActifs">
            {{'TREEVIEW.ACTIVE_PROJECTS' | translate}}
          </label>
        </div>

        <div class="d-flex">
          <ul id="treeview-tabs" class="nav nav-tabs not-selectable">
            <li class="nav-item epc-tab">
              <a id="tab-filtrage" class="nav-link" (click)="changerVue('filtrage')" [ngClass]="vueActuelle() == 'filtrage' ? 'active':'' ">
                <div>
                  <i class="fas fa-filter" style="padding-right: 5px;"></i>
                  {{ 'TREEVIEW.FILTRER' | translate }}
                </div>
                @if (nettoyerFiltres()) {
                  <i id="clean-filter-button" class="fas fa-eraser" (click)="clearFilters($event)"></i>
                }
              </a>
            </li>
            <li class="nav-item epc-tab not-selectable">
              <a class="nav-link" (click)="changerVue('parametres')" [ngClass]="{'active':vueActuelle() == 'parametres'} ">
                <i class="fas fa-cogs" style="padding-right: 5px;"></i>
                {{ 'TREEVIEW.PARAMETRES' | translate }}
              </a>
            </li>

          </ul>
        </div>

        @if (hasFilterItems() && vueActuelle() === 'treeview' && selectionActivee() === true && config.hasAllCheckBox) {
          <div class="form-check form-check-inline my-2 not-selectable">
            <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onAllCheckedChange()"
              [indeterminate]="item.indeterminate" />
              <label class="form-check-label" (click)="item.checked = !item.checked; onAllCheckedChange();">
                {{ 'TREEVIEW.TOUT_SELECTIONNER' | translate }}
              </label>
            </div>
          }
        </ng-template>

        <div class="treeview-wrapper">
          <div class="treeview-header">
            <ng-template [ngTemplateOutlet]="defaultHeaderTemplate" [ngTemplateOutletContext]="headerTemplateContext()">
            </ng-template>
          </div>

          @switch (vueActuelle()) {
            @case ('treeview') {
              @switch (hasFilterItems()) {
                @case (true) {
                  <div class="treeview-container" [ngClass]="{'treeview-container-full-height': selectionActivee() === false}">
                    @for (item of filterItems(); track item) {
                      <app-treeview-item [config]="config()" [item]="item" (checkedChange)="onItemCheckedChange(item, $event)" [template]="(selectionActivee() ? itemTemplate : itemTemplateNoSelection)">
                      </app-treeview-item>
                    }
                  </div>
                }
                @case (false) {
                  <div class="treeview-text">
                    {{ 'TREEVIEW.FILTRE_AUCUN_ELEMENT' | translate }}
                  </div>
                }
              }
            }
            @case ('filtrage') {
              <div class="col-12 p-4 treeview-content">
                <form id="form-filtrage" (ngSubmit)="onSubmitFiltrage()">
                  <div class="form-group mb-1">
                    <label for="selectProjet">{{ 'TREEVIEW.PROJETS' | translate }}</label>
                    <ng-select name="selectProjets"
                      id="selectProjets"
                      [items]="listeProjets()"
                      [ngModel]="projetsSelectionnes()" (ngModelChange)="projetsSelectionnes.set($event)"
                      [hideSelected]="false"
                      [multiple]="true"
                      [closeOnSelect]="false">
                    </ng-select>
                  </div>
                  <div class="form-group mb-1">
                    <label for="selectType">{{ 'GLOBAL.ZONES' | translate }}</label>
                    <ng-select name="selectZones"
                      id="selectZones"
                      [items]="listeZones()"
                      bindLabel="nom"
                      [ngModel]="zonesSelectionnes()" (ngModelChange)="zonesSelectionnes.set($event)"
                      [hideSelected]="false"
                      [multiple]="true"
                      [closeOnSelect]="false">
                    </ng-select>
                  </div>
                  <div class="form-group mb-1">
                    <label for="selectType">{{ 'TREEVIEW.TYPES' | translate }}</label>
                    <ng-select name="selectTypes"
                      id="selectTypes"
                      [items]="listeTypes()"
                      bindLabel="nom"
                      [ngModel]="typesSelectionnes()" (ngModelChange)="typesSelectionnes.set($event)"
                      [hideSelected]="false"
                      [multiple]="true"
                      [closeOnSelect]="false">
                    </ng-select>
                  </div>
                  <div class="form-group mb-1">
                    <label for="selectBlasted">{{'GLOBAL.BLAST_TYPE' | translate}}</label>
                    <ng-select name="selectBlasted"
                      id="selectBlasted"
                      [items]="listeBlasted()"
                      bindLabel="label"
                      bindValue="value"
                      [ngModel]="blastedSelectionne()" (ngModelChange)="blastedSelectionne.set($event)"
                      [clearable]="true"
                      [placeholder]="'GLOBAL.BLAST_TYPE' | translate">
                    </ng-select>
                  </div>
                  <div class="form-group mb-1">
                    <label for="niveaux">{{ 'TREEVIEW.NIVEAUX' | translate }}</label>
                    <input id="niveaux" type="text" [ngModel]="niveauxSelectionnes()" (ngModelChange)="niveauxSelectionnes.set($event)" name="niveaux" class="form-control" placeholder="{{ 'TREEVIEW.NIVEAUX' | translate }}" maxlength="150" autocomplete="off" />
                  </div>
                  @if (erreurFiltreNiveaux()) {
                    <div class="custom-alert custom-alert-sm">{{'TREEVIEW.ERREUR_NIVEAUX' | translate}}</div>
                  }
                  <div class="form-group mb-1">
                    <label for="niveaux">{{ 'GLOBAL.PERIODE' | translate }}</label>
                    <div class="input-group">
                      <mat-date-range-input [rangePicker]="treeviewRangePicker">
                        <input matStartDate placeholder="{{'GLOBAL.PERIODE' | translate}}" autocomplete="off" name="drpStart" class="form-control"
                          [ngModel]="dateDebut()" (ngModelChange)="dateChange([$event, dateFin()])"
                          [max]="dateJour" readonly
                          (click)="treeviewRangePicker.open()" (focus)="treeviewRangePicker.open()">
                        <input matEndDate placeholder="{{'GLOBAL.PERIODE' | translate}}" autocomplete="off" name="drpEnd" class="form-control"
                          [ngModel]="dateFin()" (ngModelChange)="dateChange([dateDebut(), $event])"
                          [max]="dateJour" readonly
                          (click)="treeviewRangePicker.open()" (focus)="treeviewRangePicker.open()">
                      </mat-date-range-input>
                      <mat-date-range-picker #treeviewRangePicker></mat-date-range-picker>
                        @if (dateDebut() && dateFin()) {
                          <div class="input-group-prepend">
                            <button type="button" class="btn btn-outline-primary" (click)="clearDates()"><i class="fas fa-eraser"></i></button>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="btn-group mt-2" role="group">
                      <button type="submit" class="btn btn-outline-success">{{ 'GLOBAL.VALIDER' | translate }}</button>
                    </div>
                  </form>
                </div>
              }
              @case ('parametres') {
                <div class="col-12 treeview-content">
                  <p>{{ 'TREEVIEW.ORDRE_REGROUPEMENT' | translate }}</p>
                  <form id="form-regroupement" (ngSubmit)="onSubmitRegroupement()">
                    <div class="form-group mb-1">
                      <label for="selectLevelOne">{{ 'GLOBAL.NIVEAU' | translate }} 1</label>
                      <ng-select name="selectLevelOne" id="selectLevelOne" [ngModel]="configurationTreeview().niveauUn" (ngModelChange)="setConfigNiveauUn($event)" (change)="onChangeConfiguration()" [clearable]="false">
                        @for (configuration of configurationTreeviewNiveauUn; track configuration) {
                          <ng-option [value]="configuration.id">{{ configuration.nom | translate }}</ng-option>
                        }
                      </ng-select>
                    </div>
                    <div class="form-group mb-1">
                      <label for="selectLevelTwo">{{ 'GLOBAL.NIVEAU' | translate }} 2</label>
                      <ng-select name="selectLevelTwo" id="selectLevelTwo" [ngModel]="configurationTreeview().niveauDeux" (ngModelChange)="setConfigNiveauDeux($event)" (change)="onChangeConfiguration()" [clearable]="false">
                        @for (configuration of configurationTreeviewNiveauDeux(); track configuration) {
                          <ng-option [value]="configuration.id"> {{ configuration.nom | translate }}</ng-option>
                        }
                      </ng-select>
                    </div>
                    <div class="form-group mb-1">
                      <label for="selectLevelThree">{{ 'GLOBAL.NIVEAU' | translate }} 3</label>
                      <ng-select name="selectLevelThree" id="selectLevelThree" [ngModel]="configurationTreeview().niveauTrois" (ngModelChange)="setConfigNiveauTrois($event)" (change)="onChangeConfiguration()" [clearable]="false">
                        @for (configuration of configurationTreeviewNiveauTrois(); track configuration) {
                          <ng-option [value]="configuration.id">{{ configuration.nom | translate }}</ng-option>
                        }
                      </ng-select>
                    </div>
                    <div class="btn-group" role="group">
                      <button type="submit" class="btn btn-outline-success">{{ 'GLOBAL.VALIDER' | translate }}</button>
                    </div>
                  </form>
                </div>
              }
            }
          </div>


